import React, { useEffect, useRef } from "react";
import {
  Button,
  Form,
  Input,
  Upload,
  Spin,
  Row,
  Col,
  Switch,
  Divider,
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout } from "antd";
import ReactGA from "react-ga4";

import AppButton from "../../../components/common/buttons/button";
import profilePlaceholder from "../../../assets/images/profilePlaceholder.png";
import PageHeaderComponent from "../../../layout/protectedLayout/protectedLayoutStore/headers/pageHeader";
interface EditProfileComponentInterface {
  onFinish?: any;
  submitting?: boolean;
  handleImageChange?: any;
  file_list?: any;
  file?: any;
  getFieldDecorator?: any;
  updateProfileErrors?: any;
  name?: any;
  phone?: any;
  email?: any;
  profile_pic?: any;
  initialValuesOfEditProfile?: any;
  profile?: any;
  updatedProfileErrors?: any;
  loading?: any;
  userInformation?: any;
}

const EditProfileComponent: React.FC<EditProfileComponentInterface> = (
  props
) => {
  const {
    onFinish,
    submitting,
    handleImageChange,
    file_list,
    updateProfileErrors,
    updatedProfileErrors,
    loading,
    userInformation,
  } = props;

  const [form] = Form.useForm();
  const unsubscribeEndRef: any = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { Content } = Layout;

  useEffect(() => {
    form.setFieldsValue({
      name: userInformation?.userDetails?.name,
      phone: userInformation?.userDetails?.phone,
      email: userInformation?.userDetails?.email,
    });
  }, [userInformation]);

  useEffect(() => {
    if (location?.hash === "#unsubscribe") {
      unsubscribeEndRef?.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location?.hash]);

  const handleBackButton = () => {
    navigate("/store");
  };

  return (
    <>
      <Layout>
        <PageHeaderComponent />
        <Layout className="edit-profile-page">
          <Content>
            <div className="">
              <div className="editProfile">
                <div className="editProfile__container">
                  <Row justify={"center"}>
                    <Col span={24} lg={12}>
                      <div className="backButton-editProfile">
                        <Button
                          icon={<ArrowLeftOutlined />}
                          type="text"
                          size="large"
                          onClick={handleBackButton}
                        />
                      </div>
                      <Form
                        name="normal_login"
                        layout="vertical"
                        form={form}
                        onFinish={onFinish}
                        initialValues={{
                          subscribe:
                            userInformation?.userDetails?.subscribe ?? true,
                        }}
                      >
                        <h2>Edit Profile</h2>

                        <Form.Item
                          name="profile_pic"
                          className="profile_picContainer"
                          help={updateProfileErrors?.profile_pic}
                        >
                          <Upload
                            listType="picture"
                            name="profile_pic"
                            beforeUpload={() => false}
                            maxCount={1}
                            multiple={false}
                            onChange={handleImageChange}
                            // accept=".png, .jpeg"
                            iconRender={() => {
                              return <Spin />;
                            }}
                            itemRender={(existingComp, file) => {
                              return (
                                <div className="profileUpload">
                                  <img
                                    src={file.thumbUrl}
                                    width={"200px"}
                                    height={"200px"}
                                    className="profile_pic"
                                    alt=""
                                  />
                                </div>
                              );
                            }}
                          >
                            {file_list?.length ? (
                              <></>
                            ) : (
                              <div className="initialProfileUpload">
                                <img
                                  src={
                                    userInformation?.userDetails?.profile_pic ??
                                    profilePlaceholder
                                  }
                                  width={"200px"}
                                  height={"200px"}
                                  className="profile_pic"
                                  alt=""
                                />

                                <Button
                                  type="primary"
                                  size="small"
                                  className="uploadProfilePicButton"
                                >
                                  Upload Image
                                </Button>
                              </div>
                            )}
                          </Upload>
                        </Form.Item>

                        <div className="editProfile-form-wrapper">
                          <div className="login-form">
                            <Form.Item
                              name="name"
                              label="Name"
                              rules={[
                                {
                                  required: true,
                                  message: "Please input your Name!",
                                },
                              ]}
                              help={updatedProfileErrors?.name}
                            >
                              <Input placeholder="Name" disabled={submitting} />
                            </Form.Item>

                            <Form.Item
                              name="phone"
                              label="Phone number"
                              rules={[
                                {
                                  min: 10,
                                  message:
                                    "Mobile number should be of atleast 10 digits!",
                                },
                                {
                                  max: 15,
                                  message:
                                    "Mobile number should not be more than 15 digits!",
                                },
                              ]}
                              help={updateProfileErrors?.phone}
                            >
                              <Input
                                placeholder="Phone Number"
                                disabled={submitting}
                                type="number"
                              />
                            </Form.Item>

                            <Form.Item
                              name="email"
                              label="Email"
                              rules={[
                                {
                                  required: true,
                                  message: "Please input your Email!",
                                },
                                {
                                  type: "email",
                                  message: "Please input a valid Email!",
                                },
                              ]}
                              help={updatedProfileErrors?.email}
                            >
                              <Input placeholder="Email Address" disabled />
                            </Form.Item>
                            <Divider />
                            {/* <Form.Item
                              name="current_password"
                              label="Old Password"
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (
                                      !value &&
                                      (getFieldValue("new_password") ||
                                        getFieldValue(
                                          "new_password_confirmation"
                                        ))
                                    ) {
                                      return Promise.reject(
                                        "Please enter your old password!"
                                      );
                                    } else {
                                      return Promise.resolve();
                                    }
                                  },
                                }),
                              ]}
                              help={updatedProfileErrors?.current_password}
                            >
                              <Input placeholder="Current Password" />
                            </Form.Item> */}
                            <Form.Item
                              name="new_password"
                              label="New Password"
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (
                                      !value &&
                                      getFieldValue("new_password_confirmation")
                                    ) {
                                      return Promise.reject(
                                        "Please enter new password!"
                                      );
                                    } else {
                                      return Promise.resolve();
                                    }
                                  },
                                }),
                              ]}
                              help={updatedProfileErrors?.new_password}
                            >
                              <Input placeholder="New Password" />
                            </Form.Item>
                            <Form.Item
                              name="new_password_confirmation"
                              label="Confirm New Password"
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    // if (
                                    //   !value &&
                                    //   (getFieldValue("new_password"))
                                    // ) {
                                    //   return Promise.reject(
                                    //     "Please enter new password!"
                                    //   );
                                    // } else {
                                    //   return Promise.resolve();
                                    // }
                                    if (
                                      !value ||
                                      getFieldValue("new_password") === value
                                    ) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      "The two passwords that you entered does not match."
                                    );
                                  },
                                }),
                              ]}
                              help={
                                updatedProfileErrors?.new_password_confirmation
                              }
                            >
                              <Input placeholder="New Password" />
                            </Form.Item>
                            <Divider />
                            <div
                              ref={unsubscribeEndRef}
                              className="unsubscribe"
                            >
                              <span>Subscribe to email</span>
                              <Form.Item
                                name="subscribe"
                                // label="Subscribe to email"
                                className="form-item"
                              >
                                <Switch
                                  defaultChecked={
                                    userInformation?.userDetails?.subscribe ??
                                    true
                                  }
                                  onChange={() => {
                                    ReactGA.event({
                                      category: "Store",
                                      action: `Subscribe to email toggled`,
                                      label:
                                        "Subscribe to email switch changed",
                                      nonInteraction: true, // optional, true/false
                                      transport: "xhr",
                                    });
                                  }}
                                />
                              </Form.Item>
                            </div>
                            <Form.Item className="form-submit-btn">
                              <AppButton
                                htmlType="submit"
                                title="Submit"
                                className="btn-primary"
                                loading={loading}
                              />
                            </Form.Item>
                          </div>
                        </div>
                      </Form>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default EditProfileComponent;
